import { useTranslation } from 'react-i18next';

/*
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

const { enqueueSnackbar } = useSnackbar();
const { t } = useTranslation();

enqueueSnackbar(
    <ErrorSnackbarMessage
        tKey="error.loadGame"
        tOptions={{ game }}
        error={e}
    />,
    {
        variant: 'error',
    }
);

variant = default | success | error | warning | info
*/

const ErrorSnackbarMessage = ({ tKey, tOptions, error }) => {
    const { t } = useTranslation();
    return (
        <div>
            <p>{t(tKey, tOptions)}</p>
            {error?.message && <code>{error.message}</code>}
        </div>
    );
};

export default ErrorSnackbarMessage;
